import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackViewedOnboardingInviteMembers.meta';

export const useTrackViewedOnboardingInviteMembers = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedOnboardingInviteMembers = useCallback(() => {
    track(META.name, undefined, { integrations: { Intercom: true } });
  }, [track]);

  return { trackViewedOnboardingInviteMembers };
};
